module.exports = __webpack_public_path__ + "img/jiuzhang-back-three@2x.a303e69c.jpg";